import { FC, useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  anchor: HTMLElement;
}

interface Hole {
  top: number;
  left: number;
  width: number;
  height: number;
}

const PADDING = 6;

const holeAround = (anchor: HTMLElement): Hole => {
  const rect = anchor.getBoundingClientRect();

  return {
    top: rect.top - PADDING,
    left: rect.left - PADDING,
    width: rect.width + PADDING * 2,
    height: rect.height + PADDING * 2,
  };
};

export const BetaTourSpotlight: FC<Props> = ({ anchor }) => {
  const [hole, setHole] = useState<Hole | null>(null);

  useLayoutEffect(() => {
    const reposition = () => setHole(holeAround(anchor));

    reposition();
    window.addEventListener('resize', reposition);
    window.addEventListener('scroll', reposition, true);

    return () => {
      window.removeEventListener('resize', reposition);
      window.removeEventListener('scroll', reposition, true);
    };
  }, [anchor]);

  if (!hole) return null;

  const bottom = hole.top + hole.height;
  const right = hole.left + hole.width;

  return createPortal(
    <div className="nc_beta-tour__spotlight" aria-hidden="true">
      <div className="nc_beta-tour__veil" style={{ top: 0, left: 0, right: 0, height: Math.max(hole.top, 0) }} />
      <div className="nc_beta-tour__veil" style={{ top: bottom, left: 0, right: 0, bottom: 0 }} />
      <div
        className="nc_beta-tour__veil"
        style={{ top: hole.top, left: 0, width: Math.max(hole.left, 0), height: hole.height }}
      />
      <div className="nc_beta-tour__veil" style={{ top: hole.top, left: right, right: 0, height: hole.height }} />
      <div
        className="nc_beta-tour__ring"
        style={{ top: hole.top, left: hole.left, width: hole.width, height: hole.height }}
      />
    </div>,
    document.body,
  );
};

export default BetaTourSpotlight;
